<template>
    <div v-if="currentBranch"
         class="dummy-branch-selector-btn clickable desktop-only no-wrap"
         data-analytics-id="Menu Modal / Order Branch Selector"
         @click.prevent="$emit('click')">
        <i class="fa-solid fa-shop fa-fw"></i>
        {{ truncateFilter(currentBranch.name, 20) }}
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    emits: ['click'],

    computed: {
        ...mapState([
            'currentBranch',
        ]),
    },
};
</script>
